import Vue from "vue";

Vue.component("crn-notification-number", {
	props: ["crnApiId", "crnNotificationNumber"],
	data() {
		return {
			loading: false,
			loadingText: window.labels.loading
		};
	},
	mounted: function () {
		if (this.crnApiId && !this.crnNotificationNumber) {
			this.loading = true;
			this.$services.crnNotifications.getCRNNotificationNumber({
				crnAPIId: this.crnApiId
			})
				.then((data) => {
					this.loading = false;
					this.$emit("update:crnNotificationNumber", data ? data.toString() : "");			
				});
		} 
	},
	template: `
			<div v-if="loading">
				<loading :loading-text="loadingText"></loading>
			</div>
			<div v-else>
				{{ crnNotificationNumber }}
			</div>		
	`
});